/* Cordelia Kraft: product image zoom (lightbox with tap / click to zoom, swipe between images). */
(function () {
  var gallery = document.querySelector('[data-ck-pdp] .ck-gallery');
  if (!gallery) return;
  var css = '.ck-gallery__item img{cursor:zoom-in}' +
    '.ck-zoom{position:fixed;inset:0;z-index:120;background:#fff;display:flex;flex-direction:column;opacity:0;transition:opacity .2s}' +
    '.ck-zoom.is-open{opacity:1}' +
    '.ck-zoom__bar{display:flex;justify-content:space-between;align-items:center;padding:12px 16px;font:600 14px var(--ck-body,sans-serif)}' +
    '.ck-zoom__btn{width:44px;height:44px;border-radius:50%;border:0;background:#F4F4F4;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#0B0B0B}' +
    '.ck-zoom__track{flex:1;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}' +
    '.ck-zoom__track::-webkit-scrollbar{display:none}' +
    '.ck-zoom__slide{flex:0 0 100%;height:100%;overflow:hidden;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;position:relative}' +
    '.ck-zoom__slide img{max-width:100%;max-height:100%;object-fit:contain;cursor:zoom-in;user-select:none;-webkit-user-drag:none}' +
    '.ck-zoom__slide.is-zoomed{overflow:auto;display:block;cursor:zoom-out}' +
    '.ck-zoom__slide.is-zoomed img{max-width:none;max-height:none;width:250%;cursor:zoom-out}' +
    '.ck-zoom__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:2}' +
    '.ck-zoom__prev{left:16px}.ck-zoom__next{right:16px}' +
    '.ck-zoom__hint{text-align:center;padding:10px 16px 16px;font:500 13px var(--ck-body,sans-serif);color:#555}' +
    '@media (max-width:749px){.ck-zoom__nav{display:none}.ck-zoom__slide.is-zoomed img{width:300%}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var items = Array.prototype.slice.call(gallery.querySelectorAll('.ck-gallery__item img'));
  if (!items.length) return;
  function big(img) {
    var s = img.currentSrc || img.src;
    return s.replace(/([?&])width=\d+/, '$1width=2400');
  }
  var box, track, counter, idx = 0, lastFocus;
  function build() {
    box = document.createElement('div');
    box.className = 'ck-zoom'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Product images');
    var x = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var l = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg>';
    var r = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg>';
    box.innerHTML = '<div class="ck-zoom__bar"><span data-count></span><button type="button" class="ck-zoom__btn" data-close aria-label="Close">' + x + '</button></div>' +
      '<div class="ck-zoom__track"></div>' +
      '<button type="button" class="ck-zoom__btn ck-zoom__nav ck-zoom__prev" data-prev aria-label="Previous image">' + l + '</button>' +
      '<button type="button" class="ck-zoom__btn ck-zoom__nav ck-zoom__next" data-next aria-label="Next image">' + r + '</button>' +
      '<div class="ck-zoom__hint">Tap the image to zoom in. Swipe for more.</div>';
    track = box.querySelector('.ck-zoom__track'); counter = box.querySelector('[data-count]');
    items.forEach(function (img) {
      var s = document.createElement('div'); s.className = 'ck-zoom__slide';
      var i = document.createElement('img'); i.alt = img.alt || ''; i.loading = 'lazy'; i.decoding = 'async'; i.dataset.src = big(img);
      s.appendChild(i); track.appendChild(s);
    });
    document.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return close();
      if (e.target.closest('[data-prev]')) return go(idx - 1);
      if (e.target.closest('[data-next]')) return go(idx + 1);
      var slide = e.target.closest('.ck-zoom__slide');
      if (slide && e.target.tagName === 'IMG') toggleZoom(slide, e);
    });
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== idx) { unzoom(); idx = n; load(n); load(n + 1); count(); }
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(idx + 1);
      if (e.key === 'ArrowLeft') go(idx - 1);
    });
  }
  function load(n) { var s = track.children[n]; if (!s) return; var i = s.querySelector('img'); if (!i.src) i.src = i.dataset.src; }
  function count() { counter.textContent = (idx + 1) + ' / ' + items.length; }
  function unzoom() { track.querySelectorAll('.is-zoomed').forEach(function (s) { s.classList.remove('is-zoomed'); }); track.style.overflowX = ''; }
  function toggleZoom(slide, e) {
    if (slide.classList.contains('is-zoomed')) { unzoom(); return; }
    var img = slide.querySelector('img'), r = img.getBoundingClientRect();
    var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    slide.classList.add('is-zoomed'); track.style.overflowX = 'hidden';
    requestAnimationFrame(function () {
      slide.scrollLeft = img.offsetWidth * fx - slide.clientWidth / 2;
      slide.scrollTop = img.offsetHeight * fy - slide.clientHeight / 2;
    });
  }
  function go(n) { if (n < 0 || n >= items.length) return; unzoom(); track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }
  function open(n) {
    if (!box) build();
    lastFocus = document.activeElement; idx = n;
    box.style.display = 'flex'; document.documentElement.classList.add('ck-lock');
    load(n); load(n + 1); load(n - 1); count();
    requestAnimationFrame(function () { track.scrollLeft = n * track.clientWidth; box.classList.add('is-open'); box.querySelector('[data-close]').focus(); });
  }
  function close() {
    unzoom(); box.classList.remove('is-open'); document.documentElement.classList.remove('ck-lock');
    setTimeout(function () { box.style.display = 'none'; }, 200);
    if (lastFocus) lastFocus.focus();
  }
  items.forEach(function (img, n) {
    img.setAttribute('tabindex', '0'); img.setAttribute('role', 'button'); img.setAttribute('aria-label', 'Zoom image ' + (n + 1));
    img.addEventListener('click', function () { open(n); });
    img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(n); } });
  });
})();
